import PageLayout from 'pages/StudentViewSubmission/PageLayout';
import PageProvider from 'pages/StudentViewSubmission/PageProvider';

const StudentViewSubmissionPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default StudentViewSubmissionPage;
